function fadeInComments(): void {
  const container = document.querySelector<HTMLDivElement>(".p-25thanniversary-article-content__img-container");
  const comments = document.querySelectorAll<HTMLDivElement>(".p-25thanniversary-article__img-comment-container");

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.4,
  };

  if (container) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          comments.forEach((comment, index) => {
            if (comment) {
              setTimeout(() => {
                comment.style.opacity = "1";
              }, index * 800); // 0.8秒ずつ遅延
            }
          });
          observer.unobserve(container); // 一度表示したら監視を解除
        }
      });
    }, observerOptions);

    observer.observe(container);
  }
}

export { fadeInComments };
